/** Порт meta-spd client-imports/extractProtocolAndDomain.js для client-side enrichment. */
export type ExtractProtocolAndDomainResult = {
  protocol: string | null
  domain: string | null
  error?: string
}

export function extractProtocolAndDomain(
  protocolIn: string,
  domainIn: string,
): ExtractProtocolAndDomainResult {
  const trimmed = String(domainIn ?? '').trim()
  if (!trimmed) {
    return { protocol: null, domain: null, error: 'Ожидается непустая строка' }
  }

  const hasProtocol = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
  let urlToParse: string
  if (hasProtocol) {
    urlToParse = trimmed
  } else {
    const proto = String(protocolIn ?? 'https').trim() || 'https'
    urlToParse = `${proto}://${trimmed}`
  }

  try {
    const uri = new URL(urlToParse)
    const domain = uri.hostname
    if (!domain) {
      return {
        protocol: uri.protocol.replace(/:$/, '') || null,
        domain: null,
        error: 'Доменное имя отсутствует в URI',
      }
    }
    return {
      protocol: uri.protocol.replace(/:$/, ''),
      domain,
    }
  } catch (e) {
    const errorMsg = e instanceof Error ? e.message : String(e)
    return { protocol: null, domain: null, error: `Ошибка парсинга: ${errorMsg}` }
  }
}
